import React, { useState, useEffect } from 'react';
import axios from 'axios';
import jsPDF from 'jspdf';
import { FaArrowLeft, FaFilePdf, FaCalculator, FaCar, FaUser, FaPhone, FaCalendarAlt, FaDollarSign, FaCheckCircle } from 'react-icons/fa';

export default function Cotizar({ goBack }) {
    const [vehiculos, setVehiculos] = useState([]);
    const [selectedCar, setSelectedCar] = useState(null);
    const [loading, setLoading] = useState(false);
    
    const [form, setForm] = useState({ 
        cliente: '', 
        telefono: '', 
        dias: 1,
        precioUnitario: 0
    });

    useEffect(() => {
        axios.get('https://api.alquilacarbolivia.com/api/vehiculos').then(res => {
            setVehiculos(res.data);
        });
    }, []);

    const handleSelectCar = (car) => {
        setSelectedCar(car);
        setForm(prev => ({ 
            ...prev, 
            precioUnitario: car.precio_dia
        }));
    };

    const getBase64ImageFromURL = (url) => {
        return new Promise((resolve, reject) => {
            const img = new Image();
            img.setAttribute('crossOrigin', 'anonymous');
            img.onload = () => {
                const canvas = document.createElement('canvas');
                canvas.width = img.width;
                canvas.height = img.height;
                const ctx = canvas.getContext('2d');
                ctx.drawImage(img, 0, 0);
                const dataURL = canvas.toDataURL('image/jpeg');
                resolve(dataURL);
            };
            img.onerror = error => resolve(null);
            img.src = url;
        });
    };

    const generarPDF = async () => {
  setLoading(true);
  const total = form.dias * form.precioUnitario;
  const doc = new jsPDF();
  const pageWidth = doc.internal.pageSize.width;
  const pageHeight = doc.internal.pageSize.height;

  // ============================================
  // PALETA DE COLORES PREMIUM
  // ============================================
  const colors = {
    sidebar: [26, 35, 46],        // Azul oscuro elegante
    primary: [52, 152, 219],      // Azul moderno
    accent: [230, 126, 34],       // Naranja sofisticado
    success: [46, 204, 113],      // Verde
    textMain: [44, 62, 80],       // Gris oscuro
    textMuted: [149, 165, 166],   // Gris medio
    lightBg: [236, 240, 241],     // Gris claro
    white: [255, 255, 255],
    gold: [241, 196, 15]          // Dorado para detalles
  };

  // ============================================
  // SIDEBAR LATERAL IZQUIERDA
  // ============================================
  const sidebarWidth = 65;
  
  // Fondo principal del sidebar
  doc.setFillColor(...colors.sidebar);
  doc.rect(0, 0, sidebarWidth, pageHeight, 'F');
  
  // Franja decorativa dorada
  doc.setFillColor(...colors.gold);
  doc.rect(sidebarWidth - 2, 0, 2, pageHeight, 'F');

  let sideY = 20;
  
  // --- LOGO Y MARCA ---
doc.setTextColor(15, 20, 25);
doc.setFontSize(28);
doc.setFont("helvetica", "bold");
doc.text('ALQUILA', 11, sideY + 1);

// Texto principal
doc.setTextColor(...colors.white);
doc.text('ALQUILA', 10, sideY);

sideY += 9;
// Sombra
doc.setTextColor(15, 20, 25);
doc.text('CAR', 11, sideY + 1);

// Texto con gradiente simulado (dorado)
doc.setTextColor(...colors.gold);
doc.text('CAR', 10, sideY);

sideY += 4;
// Subrayado elegante
doc.setFillColor(...colors.accent);
doc.roundedRect(10, sideY, 25, 2, 1, 1, 'F');  


  // --- NÚMERO DE COTIZACIÓN (Destacado) ---
  sideY += 15;
  const numCotizacion = `${Date.now().toString().slice(-6)}`;
  
  // Caja con borde dorado
  doc.setFillColor(35, 45, 58);
  doc.roundedRect(8, sideY - 3, sidebarWidth - 16, 32, 3, 3, 'F');
  
  doc.setDrawColor(...colors.gold);
  doc.setLineWidth(1.5);
  doc.roundedRect(8, sideY - 3, sidebarWidth - 16, 32, 3, 3, 'S');
  
  doc.setTextColor(...colors.gold);
  doc.setFontSize(7);
  doc.setFont("helvetica", "bold");
  doc.text('COTIZACIÓN No', 12, sideY + 2);
  
  doc.setTextColor(...colors.white);
  doc.setFontSize(14);
  doc.setFont("helvetica", "bold");
  doc.text(`#${numCotizacion}`, 12, sideY + 10);
  
  doc.setFontSize(7);
  doc.setFont("helvetica", "normal");
  doc.setTextColor(180, 180, 180);
  doc.text(new Date().toLocaleDateString('es-ES'), 12, sideY + 17);
  
  // Badge de validez
  doc.setFillColor(...colors.accent);
  doc.roundedRect(12, sideY + 21, 38, 6, 2, 2, 'F');
  doc.setTextColor(...colors.white);
  doc.setFontSize(6);
  doc.setFont("helvetica", "bold");
  doc.text('VÁLIDO 48 HORAS', 31, sideY + 25, { align: 'center' });

  // --- INFORMACIÓN DEL CLIENTE ---
  sideY += 45;
  doc.setFontSize(7);
  doc.setTextColor(...colors.gold);
  doc.setFont("helvetica", "bold");
  doc.text('CLIENTE', 10, sideY);

  sideY += 6;
  doc.setFontSize(11);
  doc.setTextColor(...colors.white);
  doc.setFont("helvetica", "bold");
  const clienteNombre = doc.splitTextToSize(form.cliente.toUpperCase(), sidebarWidth - 20);
  doc.text(clienteNombre, 10, sideY);
  
  sideY += (clienteNombre.length * 6) + 2;
  doc.setFontSize(8);
  doc.setFont("helvetica", "normal");
  doc.setTextColor(200, 200, 200);
  doc.text(`Tel: ${form.telefono || 'No especificado'}`, 10, sideY);

  // --- DATOS DE CONTACTO ---
  sideY += 25;
  doc.setFontSize(7);
  doc.setTextColor(...colors.gold);
  doc.setFont("helvetica", "bold");
  doc.text('CONTACTO', 10, sideY);

  sideY += 6;
  doc.setFontSize(8);
  doc.setTextColor(...colors.white);
  doc.setFont("helvetica", "normal");
  
  const direccion = doc.splitTextToSize('Av. 2do Anillo #123 Comericial Mia Plaza, Santa Cruz', sidebarWidth - 20);
  doc.text(direccion, 10, sideY);
  sideY += (direccion.length * 4) + 4;

  doc.text('+591 76858566', 10, sideY);
  sideY += 5;
  doc.text('jpsandoval@alquilacarbolivia.com', 10, sideY);

  // --- FOOTER DEL SIDEBAR ---
  const sideFooterY = pageHeight - 20;
  doc.setFontSize(6);
  doc.setTextColor(120, 120, 120);
  doc.setFont("helvetica", "italic");
  const footerText = doc.splitTextToSize('Tu compañero de viaje confiable', sidebarWidth - 20);
  doc.text(footerText, 10, sideFooterY);

  // ============================================
  // ÁREA PRINCIPAL DE CONTENIDO
  // ============================================
  const mainX = sidebarWidth + 15;
  const contentWidth = pageWidth - sidebarWidth - 25;
  let mainY = 20;

  // --- ENCABEZADO PRINCIPAL ---
  doc.setTextColor(...colors.textMain);
  doc.setFontSize(26);
  doc.setFont("helvetica", "bold");
  doc.text('Propuesta de Renta', mainX, mainY);
  
  mainY += 4;
  doc.setFillColor(...colors.primary);
  doc.rect(mainX, mainY, 60, 3, 'F');

  // --- SECCIÓN DEL VEHÍCULO ---
  mainY += 18;
  
  // Card contenedor del vehículo
  const vehicleCardY = mainY;
  doc.setFillColor(0, 0, 0, 0.03);
  doc.roundedRect(mainX + 1, vehicleCardY + 1, contentWidth, 75, 4, 4, 'F');
  
  doc.setFillColor(...colors.white);
  doc.roundedRect(mainX, vehicleCardY, contentWidth, 75, 4, 4, 'F');
  doc.setDrawColor(...colors.lightBg);
  doc.setLineWidth(1);
  doc.roundedRect(mainX, vehicleCardY, contentWidth, 75, 4, 4, 'S');

  // Header del vehículo
  doc.setFillColor(...colors.primary);
  doc.roundedRect(mainX, vehicleCardY, contentWidth, 12, 4, 4, 'F');
  doc.rect(mainX, vehicleCardY + 8, contentWidth, 4, 'F');
  
  doc.setTextColor(...colors.white);
  doc.setFontSize(11);
  doc.setFont("helvetica", "bold");
  doc.text('VEHÍCULO SELECCIONADO', mainX + 5, vehicleCardY + 8);

  // Nombre del vehículo
  mainY = vehicleCardY + 22;
  doc.setTextColor(...colors.primary);
  doc.setFontSize(20);
  doc.setFont("helvetica", "bold");
  doc.text(`${selectedCar.marca} ${selectedCar.modelo}`.toUpperCase(), mainX + 5, mainY);

  // Área de imagen y especificaciones
  const imgStartY = mainY + 8;
  const imgHeight = 50;
  const imgWidth = 75;
  
  // Imagen del vehículo
  if (selectedCar.imagen_url) {
    try {
      const imgBase64 = await getBase64ImageFromURL(selectedCar.imagen_url);
      if (imgBase64) {
        // Marco para la imagen
        doc.setFillColor(...colors.lightBg);
        doc.roundedRect(mainX + 5, imgStartY, imgWidth, imgHeight, 3, 3, 'F');
        
        doc.setDrawColor(...colors.lightBg);
        doc.setLineWidth(2);
        doc.roundedRect(mainX + 5, imgStartY, imgWidth, imgHeight, 3, 3, 'S');
        
        doc.addImage(imgBase64, 'JPEG', mainX + 7, imgStartY + 2, imgWidth - 4, imgHeight - 4);
      }
    } catch (e) {
      console.error('Error cargando imagen:', e);
    }
  } else {
    // Placeholder
    doc.setFillColor(...colors.lightBg);
    doc.roundedRect(mainX + 5, imgStartY, imgWidth, imgHeight, 3, 3, 'F');
    doc.setTextColor(...colors.textMuted);
    doc.setFontSize(10);
    doc.text('Sin imagen', mainX + imgWidth/2 + 5, imgStartY + imgHeight/2, { align: 'center' });
  }

  // Especificaciones (Grid 2x2)
  const specsX = mainX + imgWidth + 15;
  let specsY = imgStartY + 5;
  
  const specs = [
    { label: 'Año', value: selectedCar.anio },
    { label: 'Kilometraje', value: `${selectedCar.kilometraje_actual || 0} km` },
    { label: 'Color', value: selectedCar.color },
    { label: 'Placa', value: selectedCar.placa }
  ];

  specs.forEach((spec, i) => {
    if (i === 2) {
      specsY += 16;
    }
    
    const xPos = i % 2 === 0 ? specsX : specsX + 42;
    const yPos = specsY + (i < 2 ? 0 : 0);
    
    // Mini card para cada spec
    doc.setFillColor(...colors.lightBg);
    doc.roundedRect(xPos, yPos - 3, 38, 13, 2, 2, 'F');
    
    doc.setFontSize(7);
    doc.setTextColor(...colors.textMuted);
    doc.setFont("helvetica", "bold");
    doc.text(spec.label.toUpperCase(), xPos + 2, yPos + 1);
    
    doc.setFontSize(11);
    doc.setTextColor(...colors.textMain);
    doc.setFont("helvetica", "bold");
    doc.text(spec.value.toString(), xPos + 2, yPos + 7);
  });

  // Badge de disponibilidad
  specsY += 22;
  doc.setFillColor(...colors.success);
  doc.roundedRect(specsX, specsY, 35, 7, 2, 2, 'F');
  doc.setTextColor(...colors.white);
  doc.setFontSize(8);
  doc.setFont("helvetica", "bold");
  doc.text('DISPONIBLE', specsX + 17.5, specsY + 4.5, { align: 'center' });

  // --- DESGLOSE DE COSTOS ---
  mainY = vehicleCardY + 85;
  
  doc.setFontSize(14);
  doc.setTextColor(...colors.textMain);
  doc.setFont("helvetica", "bold");
  doc.text('Desglose de Costos', mainX, mainY);
  
  mainY += 3;
  doc.setFillColor(...colors.accent);
  doc.rect(mainX, mainY, 45, 2, 'F');
  
  mainY += 12;
  
  // Tabla header
  doc.setFillColor(...colors.lightBg);
  doc.rect(mainX, mainY, contentWidth, 10, 'F');
  
  doc.setFontSize(8);
  doc.setTextColor(...colors.textMain);
  doc.setFont("helvetica", "bold");
  doc.text('DESCRIPCIÓN', mainX + 3, mainY + 6.5);
  doc.text('CANT', mainX + contentWidth - 65, mainY + 6.5);
  doc.text('PRECIO/DÍA', mainX + contentWidth - 45, mainY + 6.5);
  doc.text('TOTAL', mainX + contentWidth - 3, mainY + 6.5, { align: 'right' });

  // Línea de item
  mainY += 15;
  doc.setFontSize(10);
  doc.setFont("helvetica", "bold");
  doc.setTextColor(...colors.textMain);
  doc.text(`Renta ${selectedCar.marca} ${selectedCar.modelo}`, mainX + 3, mainY);
  
  doc.setFontSize(7);
  doc.setFont("helvetica", "normal");
  doc.setTextColor(...colors.textMuted);
  doc.text('Incluye seguro básico y kilometraje ilimitado', mainX + 3, mainY + 4);
  
  doc.setFontSize(10);
  doc.setTextColor(...colors.textMain);
  doc.setFont("helvetica", "bold");
  doc.text(form.dias.toString(), mainX + contentWidth - 65, mainY);
  doc.text(`Bs ${parseFloat(form.precioUnitario).toFixed(2)}`, mainX + contentWidth - 45, mainY);
  doc.text(`Bs ${total.toFixed(2)}`, mainX + contentWidth - 3, mainY, { align: 'right' });

  // Separador
  mainY += 8;
  doc.setDrawColor(...colors.lightBg);
  doc.setLineWidth(1);
  doc.line(mainX, mainY, mainX + contentWidth, mainY);

  // --- SECCIÓN TOTAL Y BENEFICIOS ---
  mainY += 15;
  
  // Columna izquierda: Beneficios
  let benefitsY = mainY;
  
  // INCLUYE
  doc.setFillColor(232, 255, 235);
  doc.roundedRect(mainX, benefitsY, 55, 28, 3, 3, 'F');
  
  doc.setFillColor(...colors.success);
  doc.roundedRect(mainX, benefitsY, 55, 8, 3, 3, 'F');
  doc.rect(mainX, benefitsY + 5, 55, 3, 'F');
  
  doc.setTextColor(...colors.white);
  doc.setFontSize(9);
  doc.setFont("helvetica", "bold");
  doc.text('INCLUYE', mainX + 27.5, benefitsY + 5.5, { align: 'center' });
  
  benefitsY += 12;
  doc.setTextColor(...colors.textMain);
  doc.setFontSize(7);
  doc.setFont("helvetica", "normal");
  doc.text('• Kilometraje ilimitado', mainX + 3, benefitsY);
  doc.text('• Asistencia 24/7', mainX + 3, benefitsY + 4);
  doc.text('• Seguro contra terceros', mainX + 3, benefitsY + 8);
  doc.text('• Tanque lleno', mainX + 3, benefitsY + 12);

  // NO INCLUYE
  let noIncludeX = mainX + 60;
  benefitsY = mainY;
  
  doc.setFillColor(255, 235, 238);
  doc.roundedRect(noIncludeX, benefitsY, 55, 28, 3, 3, 'F');
  
  doc.setFillColor(...colors.accent);
  doc.roundedRect(noIncludeX, benefitsY, 55, 8, 3, 3, 'F');
  doc.rect(noIncludeX, benefitsY + 5, 55, 3, 'F');
  
  doc.setTextColor(...colors.white);
  doc.setFontSize(9);
  doc.setFont("helvetica", "bold");
  doc.text('NO INCLUYE', noIncludeX + 27.5, benefitsY + 5.5, { align: 'center' });
  
  benefitsY += 12;
  doc.setTextColor(...colors.textMain);
  doc.setFontSize(7);
  doc.setFont("helvetica", "normal");
  doc.text('• Combustible adicional', noIncludeX + 3, benefitsY);
  doc.text('• Peajes y multas', noIncludeX + 3, benefitsY + 4);
  doc.text('• Conductor adicional', noIncludeX + 3, benefitsY + 8);
  doc.text('• Seguro full', noIncludeX + 3, benefitsY + 12);

  // Columna derecha: TOTAL (Destacado)
  const totalBoxX = mainX + contentWidth - 65;
  const totalBoxY = mainY - 5;
  
  // Sombra
  doc.setFillColor(0, 0, 0, 0.08);
  doc.roundedRect(totalBoxX + 2, totalBoxY + 2, 65, 38, 4, 4, 'F');
  
  // Caja principal
  doc.setFillColor(232, 245, 255);
  doc.roundedRect(totalBoxX, totalBoxY, 65, 38, 4, 4, 'F');
  
  doc.setDrawColor(...colors.primary);
  doc.setLineWidth(2);
  doc.roundedRect(totalBoxX, totalBoxY, 65, 38, 4, 4, 'S');
  
  doc.setTextColor(...colors.textMuted);
  doc.setFontSize(9);
  doc.setFont("helvetica", "bold");
  doc.text('TOTAL A PAGAR', totalBoxX + 32.5, totalBoxY + 10, { align: 'center' });
  
  doc.setTextColor(...colors.primary);
  doc.setFontSize(24);
  doc.setFont("helvetica", "bold");
  doc.text(`Bs ${total.toFixed(2)}`, totalBoxX + 32.5, totalBoxY + 25, { align: 'center' });
  
  doc.setFontSize(7);
  doc.setTextColor(...colors.textMuted);
  doc.setFont("helvetica", "normal");
  doc.text('Impuestos incluidos', totalBoxX + 32.5, totalBoxY + 31, { align: 'center' });

  // --- NOTA IMPORTANTE (FOOTER) ---
  mainY += 40;
  
  doc.setFillColor(0, 0, 0, 0.03);
  doc.roundedRect(mainX + 1, mainY + 1, contentWidth, 20, 3, 3, 'F');
  
  doc.setFillColor(255, 248, 220);
  doc.roundedRect(mainX, mainY, contentWidth, 20, 3, 3, 'F');
  
  doc.setDrawColor(...colors.accent);
  doc.setLineWidth(1);
  doc.roundedRect(mainX, mainY, contentWidth, 20, 3, 3, 'S');
  
  doc.setTextColor(...colors.accent);
  doc.setFontSize(9);
  doc.setFont("helvetica", "bold");
  doc.text('TÉRMINOS Y CONDICIONES', mainX + 4, mainY + 6);
  
  doc.setTextColor(...colors.textMain);
  doc.setFontSize(7);
  doc.setFont("helvetica", "normal");
  doc.text('• Esta cotización es válida por 48 horas. Se requiere depósito del 30% para confirmar.', mainX + 4, mainY + 11);
  doc.text('• Requisitos: CI vigente, licencia actualizada, mayor de 21 años.', mainX + 4, mainY + 15);

  // Footer final
  const finalFooterY = pageHeight - 10;
  doc.setFontSize(7);
  doc.setTextColor(...colors.textMuted);
  doc.setFont("helvetica", "italic");
  doc.text(`Generado el ${new Date().toLocaleDateString('es-ES')} a las ${new Date().toLocaleTimeString('es-ES')}`, 
    mainX + contentWidth/2, finalFooterY, { align: 'center' });

  // Guardar
  doc.save(`Cotizacion_${numCotizacion}_${form.cliente.replace(/\s+/g, '_')}.pdf`);
  setLoading(false);
};

    const calcularTotal = () => {
        return (form.dias * form.precioUnitario).toFixed(2);
    };

    return (
        <div className="min-vh-100" style={{ 
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            position: 'relative',
            overflow: 'hidden'
        }}>
            {/* Patrón de fondo */}
            <div style={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundImage: 'radial-gradient(circle at 1px 1px, rgba(255,255,255,0.08) 1px, transparent 0)',
                backgroundSize: '40px 40px',
                zIndex: 0
            }}></div>

            {/* HEADER PREMIUM */}
            <div className="position-relative" style={{ 
                background: 'rgba(255, 255, 255, 0.08)',
                backdropFilter: 'blur(20px)',
                borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
                boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)',
                zIndex: 10
            }}>
                <div className="container-fluid p-4">
                    <div className="d-flex justify-content-between align-items-center flex-wrap gap-3">
                        <div className="d-flex align-items-center gap-3">
                            <button 
                                className="btn shadow-lg" 
                                onClick={goBack}
                                style={{
                                    background: 'rgba(255, 255, 255, 0.15)',
                                    backdropFilter: 'blur(10px)',
                                    border: '1px solid rgba(255, 255, 255, 0.2)',
                                    color: 'white',
                                    borderRadius: '15px',
                                    padding: '10px 20px',
                                    transition: 'all 0.3s ease'
                                }}
                                onMouseEnter={(e) => {
                                    e.target.style.background = 'rgba(255, 255, 255, 0.25)';
                                    e.target.style.transform = 'translateX(-5px)';
                                }}
                                onMouseLeave={(e) => {
                                    e.target.style.background = 'rgba(255, 255, 255, 0.15)';
                                    e.target.style.transform = 'translateX(0)';
                                }}
                            >
                                <FaArrowLeft className="me-2" />
                                Volver
                            </button>
                            
                            <div>
                                <h3 className="mb-0 fw-bold text-white d-flex align-items-center gap-2" style={{
                                    textShadow: '0 4px 12px rgba(0,0,0,0.3)',
                                    fontSize: '1.8rem'
                                }}>
                                    <FaCalculator style={{ fontSize: '2rem' }} />
                                    GENERADOR DE COTIZACIONES
                                </h3>
                                <p className="mb-0 small" style={{ color: 'rgba(255,255,255,0.7)' }}>
                                    Sistema profesional de cotización • {vehiculos.length} vehículos disponibles
                                </p>
                            </div>
                        </div>
                        
                        <div className="text-end">
                            <div className="badge shadow-lg" style={{
                                background: 'rgba(255, 215, 0, 0.2)',
                                backdropFilter: 'blur(10px)',
                                border: '1px solid rgba(255, 215, 0, 0.3)',
                                color: '#ffd700',
                                fontSize: '1rem',
                                padding: '0.8rem 1.5rem',
                                borderRadius: '15px'
                            }}>
                                ✓ Formato Moderno y Visual
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="container-fluid p-4 position-relative" style={{ zIndex: 1 }}>
                <div className="row g-4">
                    {/* LISTA DE VEHICULOS */}
                    <div className="col-lg-5">
                        <div 
                            className="card border-0 shadow-lg h-100" 
                            style={{
                                borderRadius: '25px',
                                overflow: 'hidden',
                                background: 'rgba(255, 255, 255, 0.95)',
                                backdropFilter: 'blur(20px)'
                            }}
                        >
                            <div style={{
                                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                color: 'white',
                                padding: '1.5rem'
                            }}>
                                <h5 className="mb-0 fw-bold d-flex align-items-center gap-2">
                                    <FaCar style={{ fontSize: '1.5rem' }} />
                                    Paso 1: Seleccione el Vehículo
                                </h5>
                            </div>
                            
                            <div className="card-body p-0">
                                <div 
                                    className="list-group list-group-flush" 
                                    style={{ maxHeight: '600px', overflow: 'auto' }}
                                >
                                    {vehiculos.map((car, index) => (
                                        <button 
                                            key={car.id} 
                                            className={`list-group-item list-group-item-action border-0 p-4 ${selectedCar?.id === car.id ? 'active' : ''}`}
                                            onClick={() => handleSelectCar(car)}
                                            style={{
                                                transition: 'all 0.3s',
                                                background: selectedCar?.id === car.id 
                                                    ? 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' 
                                                    : 'white',
                                                borderLeft: selectedCar?.id === car.id 
                                                    ? '5px solid #ffd700' 
                                                    : '5px solid transparent'
                                            }}
                                        >
                                            <div className="d-flex justify-content-between align-items-center">
                                                <div className="flex-grow-1">
                                                    <div className="d-flex align-items-center mb-2">
                                                        <FaCar className={`me-2 ${selectedCar?.id === car.id ? 'text-warning' : 'text-primary'}`} />
                                                        <h6 className={`mb-0 fw-bold ${selectedCar?.id === car.id ? 'text-white' : 'text-dark'}`}>
                                                            {car.marca} {car.modelo}
                                                        </h6>
                                                    </div>
                                                    <div className="d-flex gap-3">
                                                        <small className={selectedCar?.id === car.id ? 'text-white-50' : 'text-muted'}>
                                                            <strong>Año:</strong> {car.anio}
                                                        </small>
                                                        <small className={selectedCar?.id === car.id ? 'text-white-50' : 'text-muted'}>
                                                            <strong>Placa:</strong> {car.placa}
                                                        </small>
                                                    </div>
                                                </div>
                                                <div className="text-end ms-3">
                                                    <div className={`badge fs-6 px-3 py-2 ${selectedCar?.id === car.id ? 'bg-warning text-dark' : 'bg-primary'}`}>
                                                        <FaDollarSign className="me-1" />
                                                        Bs. {car.precio_dia}
                                                    </div>
                                                    <small className={`d-block mt-1 ${selectedCar?.id === car.id ? 'text-white-50' : 'text-muted'}`}>
                                                        por día
                                                    </small>
                                                </div>
                                            </div>
                                        </button>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* FORMULARIO */}
                    <div className="col-lg-7">
                        <div 
                            className="card border-0 shadow-lg h-100" 
                            style={{
                                borderRadius: '25px',
                                overflow: 'hidden',
                                background: 'rgba(255, 255, 255, 0.95)',
                                backdropFilter: 'blur(20px)'
                            }}
                        >
                            <div style={{
                                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                color: 'white',
                                padding: '1.5rem'
                            }}>
                                <div className="d-flex justify-content-between align-items-center">
                                    <h5 className="mb-0 fw-bold d-flex align-items-center gap-2">
                                        <FaUser style={{ fontSize: '1.5rem' }} />
                                        Paso 2: Complete los Datos
                                    </h5>
                                    {selectedCar && (
                                        <span className="badge bg-warning text-dark fs-6 px-3 py-2">
                                            {selectedCar.marca} {selectedCar.modelo}
                                        </span>
                                    )}
                                </div>
                            </div>
                            
                            <div className="card-body p-4" style={{ background: 'linear-gradient(180deg, #f8f9fa 0%, #ffffff 100%)' }}>
                                {selectedCar ? (
                                    <form onSubmit={(e) => { e.preventDefault(); generarPDF(); }}>
                                        {/* Información del Cliente */}
                                        <div className="mb-4 p-4 bg-white rounded-4 shadow-sm">
                                            <h6 className="fw-bold mb-3 pb-2 border-bottom" style={{ color: '#667eea' }}>
                                                <FaUser className="me-2" />
                                                Información del Cliente
                                            </h6>
                                            <div className="row g-3">
                                                <div className="col-md-8">
                                                    <label className="form-label fw-bold small text-secondary">
                                                        <FaUser className="me-1" /> Nombre Completo o Empresa *
                                                    </label>
                                                    <input 
                                                        className="form-control form-control-lg shadow-sm" 
                                                        required 
                                                        placeholder="Ej: Juan Pérez García"
                                                        style={{ borderRadius: '15px', border: '2px solid #e0e0e0' }}
                                                        onChange={e => setForm({...form, cliente: e.target.value})}
                                                    />
                                                </div>
                                                <div className="col-md-4">
                                                    <label className="form-label fw-bold small text-secondary">
                                                        <FaPhone className="me-1" /> Teléfono
                                                    </label>
                                                    <input 
                                                        className="form-control form-control-lg shadow-sm" 
                                                        placeholder="777..."
                                                        style={{ borderRadius: '15px', border: '2px solid #e0e0e0' }}
                                                        onChange={e => setForm({...form, telefono: e.target.value})}
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        {/* Detalles de la Cotización */}
                                        <div className="mb-4 p-4 bg-white rounded-4 shadow-sm">
                                            <h6 className="fw-bold mb-3 pb-2 border-bottom" style={{ color: '#667eea' }}>
                                                <FaCalculator className="me-2" />
                                                Detalles de la Cotización
                                            </h6>
                                            <div className="row g-4">
                                                <div className="col-md-6">
                                                    <label className="form-label fw-bold small text-secondary">
                                                        <FaCalendarAlt className="me-1" /> Cantidad de Días *
                                                    </label>
                                                    <input 
                                                        type="number" 
                                                        className="form-control form-control-lg text-center fw-bold shadow-sm" 
                                                        min="1" 
                                                        value={form.dias} 
                                                        onChange={e => setForm({...form, dias: e.target.value})}
                                                        style={{ 
                                                            borderRadius: '15px', 
                                                            fontSize: '1.8rem', 
                                                            border: '3px solid #667eea',
                                                            color: '#667eea'
                                                        }}
                                                    />
                                                </div>

                                                <div className="col-md-6">
                                                    <label className="form-label fw-bold small text-secondary">
                                                        <FaDollarSign className="me-1" /> Precio por Día (Bs.) *
                                                    </label>
                                                    <input 
                                                        type="number" 
                                                        step="0.50" 
                                                        className="form-control form-control-lg text-center fw-bold shadow-sm"
                                                        value={form.precioUnitario} 
                                                        onChange={e => setForm({...form, precioUnitario: e.target.value})} 
                                                        title="Puede modificar este precio"
                                                        style={{ 
                                                            borderRadius: '15px', 
                                                            fontSize: '1.8rem', 
                                                            border: '3px solid #28a745',
                                                            color: '#28a745'
                                                        }}
                                                    />
                                                    <div className="text-center mt-2">
                                                        <span className="badge bg-success">Precio Modificable</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Resumen Total */}
                                        <div 
                                            className="p-4 rounded-4 shadow-lg text-center mb-4" 
                                            style={{ 
                                                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                                border: '4px solid #ffd700'
                                            }}
                                        >
                                            <p className="mb-2 text-white-50 fw-bold text-uppercase" style={{ letterSpacing: '2px' }}>
                                                Total Estimado
                                            </p>
                                            <h1 className="display-2 fw-bold text-white mb-0" style={{ 
                                                textShadow: '0 4px 20px rgba(0,0,0,0.3)',
                                                fontFamily: 'Arial, sans-serif'
                                            }}>
                                                Bs. {calcularTotal()}
                                            </h1>
                                            <small className="text-white-50 d-block mt-3" style={{ fontSize: '0.9rem' }}>
                                                ({form.dias} {form.dias === '1' ? 'día' : 'días'} × Bs. {parseFloat(form.precioUnitario).toFixed(2)})
                                            </small>
                                        </div>

                                        {/* Botón de Generación */}
                                        <button 
                                            type="submit" 
                                            className="btn btn-lg w-100 text-white fw-bold shadow-lg position-relative overflow-hidden"
                                            disabled={loading}
                                            style={{ 
                                                borderRadius: '20px',
                                                background: loading 
                                                    ? '#6c757d' 
                                                    : 'linear-gradient(135deg, #11998e 0%, #38ef7d 100%)',
                                                padding: '1.2rem',
                                                fontSize: '1.3rem',
                                                transition: 'all 0.3s',
                                                border: 'none',
                                                textTransform: 'uppercase',
                                                letterSpacing: '1px'
                                            }}
                                            onMouseEnter={(e) => {
                                                if (!loading) {
                                                    e.target.style.transform = 'scale(1.02)';
                                                    e.target.style.boxShadow = '0 15px 40px rgba(17, 153, 142, 0.4)';
                                                }
                                            }}
                                            onMouseLeave={(e) => {
                                                e.target.style.transform = 'scale(1)';
                                                e.target.style.boxShadow = '';
                                            }}
                                        >
                                            {loading ? (
                                                <>
                                                    <span className="spinner-border spinner-border-sm me-3" role="status"></span>
                                                    Generando Documento...
                                                </>
                                            ) : (
                                                <>
                                                    <FaFilePdf className="me-3" size={28} />
                                                    Descargar Cotización PDF
                                                </>
                                            )}
                                        </button>

                                        <div className="text-center mt-4">
                                            <div className="d-flex justify-content-center align-items-center gap-2 text-success">
                                                <FaCheckCircle size={18} />
                                                <small className="fw-bold">
                                                    Nuevo formato moderno y visual
                                                </small>
                                            </div>
                                        </div>
                                    </form>
                                ) : (
                                    <div className="d-flex flex-column align-items-center justify-content-center" style={{ minHeight: '500px' }}>
                                        <div 
                                            className="rounded-circle d-flex align-items-center justify-content-center mb-4"
                                            style={{
                                                width: '120px',
                                                height: '120px',
                                                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                                opacity: 0.2
                                            }}
                                        >
                                            <FaCalculator size={60} style={{ color: 'white' }} />
                                        </div>
                                        <h4 className="mb-3 fw-bold" style={{ color: '#667eea' }}>
                                            Seleccione un Vehículo
                                        </h4>
                                        <p className="text-muted text-center mb-4" style={{ maxWidth: '400px' }}>
                                            Elija un vehículo de la lista de la izquierda para comenzar a generar su cotización profesional
                                        </p>
                                        <div className="badge bg-light text-dark border px-4 py-3" style={{ fontSize: '1rem' }}>
                                            <FaCar className="me-2" />
                                            Paso 1 pendiente
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* ESTILOS */}
            <style>{`
                @keyframes fadeInUp {
                    from {
                        opacity: 0;
                        transform: translateY(30px);
                    }
                    to {
                        opacity: 1;
                        transform: translateY(0);
                    }
                }

                /* Scroll personalizado */
                ::-webkit-scrollbar {
                    width: 8px;
                    height: 8px;
                }

                ::-webkit-scrollbar-track {
                    background: #f1f1f1;
                    border-radius: 10px;
                }

                ::-webkit-scrollbar-thumb {
                    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
                    border-radius: 10px;
                }

                ::-webkit-scrollbar-thumb:hover {
                    background: linear-gradient(135deg, #764ba2 0%, #667eea 100%);
                }

                /* Animaciones de hover suaves */
                .btn {
                    transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275) !important;
                }

                .list-group-item {
                    transition: all 0.3s ease !important;
                }

                .form-control:focus {
                    box-shadow: 0 0 0 0.25rem rgba(102, 126, 234, 0.25) !important;
                    border-color: #667eea !important;
                }
            `}</style>
        </div>
    );
}